/**
* @see /client/containers/GiftCardLanding/index.js
  @see /client/containers/GiftCardsList/index.js
  @see /client/containers/MyEGiftCards/index.js
* TabMenu
*/

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Container from '../Container';
import StyledTabMenu from './styledTabMenu';

const redirectItem = (item, triggerTracker) => (
  <Link to={item.link} onClick={() => triggerTracker(item.eventKey)}>
    {item.value}
  </Link>);

const clickItem = (item, { onChildClick }) => (
  <span onClick={() => onChildClick(item)} role="presentation">
    {item.value}
  </span>
);
function TabMenu(props) {
  const { pathname, links, isLink, triggerTracker, ...otherProps } = props;
  return (
    <StyledTabMenu className="hand-cursor">
      <Container>
        <ul>
          {links.map((item) => (
            <li key={item.index} className={pathname === item.link ? 'active' : ''}>
              {isLink ? redirectItem(item, triggerTracker) : clickItem(item, otherProps)}
            </li>))}
        </ul>
      </Container>
    </StyledTabMenu>
  );
}

TabMenu.propTypes = {
  pathname: PropTypes.string,
  links: PropTypes.array,
  isLink: PropTypes.bool,
  onChildClick: PropTypes.func,
  triggerTracker: PropTypes.func,
};

TabMenu.defaultProps = {
  pathname: '#/',
  isLink: true,
  onChildClick: () => '',
  triggerTracker: () => '',
};

export default TabMenu;



// WEBPACK FOOTER //
// client/components/TabMenu/index.js